export const filtering = (store) => (next) => (action) => {
  const replaceBadChars = (str) =>
    str.replace(/[&,/]/, '').trim().replace(/\s+/g, '-').toLowerCase();

  switch (action.type) {
    case 'UPDATE_POST_DATA':
      let filters = store.getState().filters;
      let data = action.filteredData;
      let filteredData = action.filteredData;
      let clearFilter;

      // loop through active user selected filters to apply filter to list
      Object.keys(filters).forEach((key) => {
        if (filters[key].active) {
          if (key === 'name') {
            let nameValue = filters[key].value;
            let sanitizedValue = nameValue.replace(/[|&;$%@"*?[\]<>()+,/\\]/g, '');
            //let re = new RegExp(`${sanitizedValue}`, 'i');
            let re = sanitizedValue.toLowerCase();
            filteredData = data.filter((posts) => {
              return posts.title.toLowerCase().match(re);
            });
          }
        }

        if (key === 'type') {
          let selectValue = filters[key].value.toLowerCase();
          if (selectValue !== '' || selectValue === 'Type') {
            // if no filter is select don't bother
            filteredData = filteredData.filter((typeMatch) => {
              return typeMatch.type.toLowerCase() === selectValue;
            });
          }
        }

        if (key === 'practice') {
          let selectValue = filters[key].value.toLowerCase();
          if (selectValue !== '' || selectValue === 'Practice') {
            // if no filter is select don't bother

            filteredData = filteredData.filter((practiceMatch) => {
              let selected;
              console.log(practiceMatch)
              practiceMatch.practices.map((practice) => {
                
                if (replaceBadChars(practice) === selectValue) {
                  selected = practiceMatch;
                }
              });
              return selected;
            });
          }
        }

        if (key === 'query') {
          return {
            query: true
          };
        }

        if (key === 'industry') {
          let selectValue = filters[key].value.toLowerCase();
          if (selectValue !== '' || selectValue === 'Industry') {
            // if no filter is select don't bother

            filteredData = filteredData.filter((industryMatch) => {
              let selected;

              industryMatch.industries.map((industry) => {
                if (industry === 'Internet') {
                  selected = industryMatch; // solves for the comma bug; some post will split "Internet as an array item, this catches that"
                }
                if (replaceBadChars(industry) === selectValue) {
                  selected = industryMatch;
                }
              });
              return selected;
            });
          }
        }

        if (key === 'attorney') {
          let selectValue = filters[key].value;
          if (selectValue !== '' || selectValue === 'Attorney') {
            // if no filter is select don't bother

            filteredData = filteredData.filter((attorneyMatch) => {
              let selected;
              attorneyMatch.people.map((attorneys) => {
                if (attorneys === selectValue) {
                  selected = attorneyMatch;
                }
              });
              return selected;
            });
          }
        }
      });

      return next({
        type: 'UPDATE_POST_DATA',
        filteredData: filteredData,
        value: action.value,
        clearFilter
      });

    default:
      return next(action);
  }
};
